import type { RouteType } from '~/types/router'

const Layout = () => import('@/layout/index.vue')

// 成绩统计分析从成绩列表进入，不作为独立菜单展示。
export default {
  name: 'examScoreAnalysisHidden',
  path: '/exam/score-analysis/:taskId',
  component: Layout,
  isHidden: true,
  meta: {
    title: '成绩统计分析',
    requireAuth: false,
  },
  children: [
    {
      name: 'examScoreAnalysis',
      path: '',
      component: () => import('./analysis.vue'),
      isHidden: true,
      meta: {
        title: '成绩统计分析',
        requireAuth: false,
      },
    },
  ],
} as RouteType
